export const MESSAGE_UPDATED = "updated"

export const POSITION_RELOAD = "reload"

